import React from "react";
import Typed from 'react-typed';
import Slide from "./Slide";
import {AiOutlineThunderbolt} from "react-icons/ai";

const Product = () => {
    return (
        <div id="product" className="text-black bg-white">
            <div className="pb-5 pt-0 max-w-[800px] mt-[-96px] w-full mx-auto text-center flex flex-col justify-center">
                <div className="p-3">
                    <h1 className='md:text-5xl sm:text-4xl text-xl font-bold py-4'>
                    <Typed
                    className='md:text-5xl sm:text-4xl text-4xl font-bold md:pl-4 pl-2'
                    strings={['လျှပ်စစ်ပစ္စည်းများ', 'အိမ်သုံးပစ္စည်းများ', 'စက်ဘီး၊ဆိုင်ကယ်များ', 'ဖုန်းအမျိုးမျိုး', 'Accessory ပစ္စည်းများ']}
                    typeSpeed={140}
                    backSpeed={150}
                    loop
                    /> 
                    </h1>
                </div>
                <p className='pt-5 md:text-2xl text-xl font-bold text-gray-500'>ပစ္စည်းမှန်၊ အရေအတွေးမှန်၊ စျေးနှုန်းမှန် ယုံကြည်စိတ်ချရသော</p>
                <Slide />
            </div>
        </div>
    )
}

export default Product;